<template>
  <VueFragment>
    <b-row class="imagegrid-container">
      <div
        v-b-modal.photography-modal
        v-for="(image, index) in images"
        :key="index"
        @click="updateSelectedIndex(index)">
        <b-img-lazy
          :src="require('../../assets/' + image.imageThumbUrl)"
          :alt="image.altDescription"
          fluid
        />
      </div>
    </b-row>

    <PhotographyModal :image="images[selectedIndex]"/>
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

import PhotographyModal from '../PhotographyModal'

export default {
  name: 'ImageGrid',
  components: {
    PhotographyModal,
    VueFragment
  },
  props: {
    title: String,
    images: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  methods: {
    updateSelectedIndex(index) {
      this.selectedIndex = index;
    }
  }
}
</script>

<style lang="scss" scoped>
.imagegrid-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  div {
    img {
      padding: 5px;
      width: 350px;

      &:hover, &:focus {
        cursor: pointer;
        opacity: 0.5;
        transition: opacity 0.3s ease-in-out;
      }

      @media (max-width: $mediaXlWidth) {
        width: 400px;
      }

      @media (max-width: $mediaLgWidth) {
        width: 300px;
      }

      @media (max-width: $mediaMdWidth) {
        width: 400px;
      }

      @media (max-width: $mediaXsWidth) {
        width: 350px;
      }
    }
  }
}
</style>
